import { atom, useAtom } from 'jotai';

export const publishTaskStartTimeAtom = atom<Date>();
export const documentHiddenTimeDuringPublishAtom = atom<number>(0);

export const usePublishTaskStartTime = () => {
  const [publishTaskStartTime, setPublishTaskStartTime] = useAtom(publishTaskStartTimeAtom);
  const [documentHiddenTimeDuringPublish, setDocumentHiddenTimeDuringPublish] = useAtom(
    documentHiddenTimeDuringPublishAtom,
  );

  return {
    publishTaskStartTime,
    setPublishTaskStartTime,
    documentHiddenTimeDuringPublish,
    setDocumentHiddenTimeDuringPublish,
  };
};
